import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { IOptionItem } from './../../model/IOptionItem';

@Component({
  selector: 'config-option',
  templateUrl: './config-option.component.html',
  styleUrls: ['./config-option.component.less']
})
export class ConfigOptionComponent implements OnInit {

  @Input()
  public display: TemplateRef<any>;

  @Input()
  public item: IOptionItem;
  @Output()
  public onSelect: EventEmitter<IOptionItem> = new EventEmitter<IOptionItem>();
  constructor() { }

  ngOnInit(): void {
  }

  public selectItem(item: IOptionItem) {
    this.onSelect.emit(item);
  }
}
